export function _isMobile(data) {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
export function textSetting(minWidth,maxWidth){   //根据屏幕宽度计算字体大（14~35px）
  let maxfs = 20;                       //最大字体
  var root = document.documentElement;
  var w = root.clientWidth;
  w = w > maxWidth ? maxWidth : w <minWidth ? minWidth : w;
  var fs = w / maxWidth * maxfs;
  root.style.fontSize = fs + "px";
  console.log(root.style.fontSize)
}
// 权限判断
export function permissions(data, code){
  let or = false
  if (data.length > 0) {
    data.forEach(item => {
      if (item.AUTHORITY_CODE === code && item.optAuth === '1') {
        or = true
      }
    })
  } else {
    or = false
  }
  return or
}

// // 基准
// const baseSize = 16
// export function setRem() {
//   console.log(2323)
//   // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
//   const scale = document.documentElement.clientWidth / 1920
//   // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
//   document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
// }



// WEBPACK FOOTER //
// ./src/assets/js/public.js